<template>
<div class="main-body">
  <b-alert
    dismissible
    :show="showDismissibleAlert"
    :variant="alertVariant"
    @dismissed="showDismissibleAlert=false">{{ alertMessage }}</b-alert>
    <form>
      <div class="card">
          <div class="card-body">
              <div class="row">
                  <div class="col-sm-5">
                      <h4 class="card-title mb-0">
                        Supplier Management <small class="text-muted">suppliers</small>
                      </h4>
                  </div><!--col-->
              </div><!--row-->

              <div class="row mt-4">
                  <div class="col">
                    <div class="form-group row">
                      <label for="primary_name" class="col-sm-2 col-form-label">{{ $t('supplier.primary_name') }}</label>
                      <div class="col-sm-6">
                        <input v-model.trim="supplier.primary_name" type="text" name="primary_name" class="form-control form__label">
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="secondary_name" class="col-sm-2 col-form-label">{{ $t('supplier.secondary_name') }}</label>
                      <div class="col-sm-6">
                        <input v-model.trim="supplier.secondary_name" type="text" name="secondary_name" class="form-control" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="address" class="col-sm-2 col-form-label">{{ $t('supplier.address') }}</label>
                      <div class="col-sm-6">
                        <input v-model.trim="supplier.address" type="text" name="address" class="form-control" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="postal_address" class="col-sm-2 col-form-label">{{ $t('supplier.postal_address') }}</label>
                      <div class="col-sm-6">
                        <input v-model.trim="supplier.postal_address" type="text" name="postal_address" class="form-control" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="payee_bank_name" class="col-sm-2 col-form-label">{{ $t('supplier.payee_bank_name') }}</label>
                      <div class="col-sm-6">
                        <input v-model.trim="supplier.payee_bank_name" type="text" name="payee_bank_name" class="form-control" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="payee_bank_swiftbic" class="col-sm-2 col-form-label">{{ $t('supplier.payee_bank_swiftbic') }}</label>
                      <div class="col-sm-6">
                        <input v-model.trim="supplier.payee_bank_swiftbic" type="text" name="payee_bank_swiftbic" class="form-control" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="payee_bank_account_name" class="col-sm-2 col-form-label">{{ $t('supplier.payee_bank_account_name') }}</label>
                      <div class="col-sm-6">
                        <input v-model.trim="supplier.payee_bank_account_name" type="text" name="payee_bank_account_name" class="form-control" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="email" class="col-sm-2 col-form-label">{{ $t('supplier.email') }}</label>
                      <div class="col-sm-6">
                        <input v-model.trim="supplier.email" type="text" name="email" class="form-control" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="tel" class="col-sm-2 col-form-label">{{ $t('supplier.tel') }}</label>
                      <div class="col-sm-3">
                        <input v-model.trim="supplier.tel" type="text" name="tel" class="form-control" />
                      </div>
                      <label for="fax" class="col-sm-2 col-form-label">{{ $t('supplier.fax') }}</label>
                      <div class="col-sm-3">
                        <input v-model.trim="supplier.fax" type="text" name="fax" class="form-control" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="mobile" class="col-sm-2 col-form-label">{{ $t('supplier.mobile') }}</label>
                      <div class="col-sm-3">
                        <input v-model.trim="supplier.mobile" type="text" name="mobile" class="form-control" />
                      </div>
                      <label for="contact_person" class="col-sm-2 col-form-label">{{ $t('supplier.contact_person') }}</label>
                      <div class="col-sm-3">
                        <input v-model.trim="supplier.contact_person" type="text" name="contact_person" class="form-control" />
                      </div>
                    </div>
                    <!-- <div class="form-group row">
                      <label for="br" class="col-sm-2 col-form-label">{{ $t('supplier.br') }}</label>
                      <div class="col-sm-6">
                        <input v-model.trim="supplier.br" type="text" name="br" class="form-control" />
                      </div>
                    </div> -->
                    <div class="form-group row">
                      <label for="status" class="col-sm-2 col-form-label">{{ $t('supplier.status') }}</label>
                      <div class="col-sm-8">
                        <CSwitch class="mx-1" :checked.sync="status" color="primary" variant="outline" shape="pill"/>
                      </div>
                    </div>
                  </div><!--col-->
              </div><!--row-->

              <div slot="footer">
                <div class="row">
                    <div class="col-7">
                        <div class="float-left"></div>
                    </div><!--col-->
                    <div class="col-5">
                        <div class="float-right">
                            <b-button type="submit" size="sm" variant="primary" @click.stop.prevent="handleSubmit"><i class="fa fa-dot-circle-o"></i> {{ $t('supplier.update') }}</b-button>
                        </div>
                    </div><!--col-->
                </div><!--row-->
              </div>
          </div><!--card-body-->
      </div><!--card-->
    </form>
   <loading-panel v-if="showLoadingPanel"></loading-panel>
  </div>
</template>
<script>
import loadingPanel from '@/components/LoadingPanel'

export default {
  name: 'SupplierEdit',
  components: {
    loadingPanel
  },
  mounted () {
    this.axios.get('/supplier/' + this.$route.params.id).then(response => {
      this.supplier = response.data
      if (this.supplier.status === 1) {
        this.status = true
      }
    }).catch(error => {
      console.log(error)
    })
  },
  data () {
    return {
      supplier: {
        id: '',
        primary_name: '',
        secondary_name: '',
        address: '',
        postal_address: '',
        payee_bank_name: '',
        payee_bank_swiftbic: '',
        payee_bank_account_name: '',
        email: '',
        tel: '',
        fax: '',
        mobile: '',
        contact_person: '',
        br: '',
        status: true
      },
      showLoadingPanel: false,
      showDismissibleAlert: false,
      alertVariant: '',
      alertMessage: '',
      status: false,
      message: ''
    }
  },
  methods: {
    handleSubmit () {
      if (this.supplier.primary_name) {
        // create supplier
        this.showLoadingPanel = true
        this.axios.put('/supplier/' + this.supplier.id, {
          ...this.supplier,
          status: this.status ? 1: 0,
        }).then(response => {
          this.showLoadingPanel = false
          this.showAlert('success', this.$t('supplier.success_message'))
          this.message = response.data
        }).catch(error => {
          this.showLoadingPanel = false
          this.showAlert('danger', error.data.message)
        })
      }
    },
    showAlert (alertVariant, message) {
      this.showDismissibleAlert = true
      this.alertVariant = alertVariant
      this.alertMessage = message
    }
  }
}
</script>
